<template>
  <b-form-group
    label="Slogan"
    label-for="title"
  >
    <validation-provider
      #default="{ errors }"
      name="Slogan"
      rules="required"
    >
      <b-form-input
        id="title"
        v-model="itemData.slogan"
        placeholder="Slogan"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'Slogan',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  computed: {
    itemData() {
      return this.$store.getters['about/dataItem']
    },
  },
}
</script>
